import { c as _c } from "react/compiler-runtime";
import { useProgressApiClient } from "@api/progress-api/use-progress-api-client";
import { useProjectApiClient } from "@api/project-api/use-project-api-client";
import { FaroTable } from "@components/common/faro-table/faro-table";
import { useDateTime } from "@hooks/use-date-time";
import { getProjectBackgroundTasksColumns } from "@pages/project-details/project-bg-tasks/project-background-tasks-columns";
import { sdbBackgroundTaskBeforePageSelector, totalCountByTypeSelector, totalCountSelector } from "@store/sdb-background-tasks/sdb-background-tasks-selector";
import { updateBackgroundTasks } from "@store/sdb-background-tasks/sdb-background-tasks-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { resetTableState, setTableType } from "@store/table/table-slice";
import { TableType } from "@utils/track-event/track-event-list";
import { useEffect } from "react";
/**
 * List of the background tasks for the currently selected project
 */
export function ProjectBackgroundTasksTable(t0) {
  const $ = _c(27);
  const {
    sdbBackgroundsTasks,
    isLoading,
    requiredColumns,
    projectId,
    taskType
  } = t0;
  const dispatch = useAppDispatch();
  let t1;
  if ($[0] !== projectId) {
    t1 = {
      projectId
    };
    $[0] = projectId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const progressApiClient = useProgressApiClient(t1);
  let t2;
  if ($[2] !== projectId) {
    t2 = {
      projectId
    };
    $[2] = projectId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const projectApiClient = useProjectApiClient(t2);
  const beforePage = useAppSelector(sdbBackgroundTaskBeforePageSelector);
  const totalCount = useAppSelector(totalCountSelector);
  const effectiveTaskType = taskType || "VideoMode";
  let t3;
  if ($[4] !== effectiveTaskType) {
    t3 = totalCountByTypeSelector(effectiveTaskType);
    $[4] = effectiveTaskType;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const totalCountForTaskType = useAppSelector(t3);
  const {
    formatDate
  } = useDateTime();
  let t4;
  let t5;
  if ($[6] !== dispatch) {
    t4 = () => {
      dispatch(setTableType(TableType.backgroundTasks));
      return () => {
        dispatch(resetTableState());
      };
    };
    t5 = [dispatch];
    $[6] = dispatch;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  const displayTotalCount = taskType ? totalCountForTaskType : totalCount;
  let t6;
  if ($[9] !== formatDate || $[10] !== requiredColumns) {
    let t7;
    if ($[12] !== formatDate) {
      t7 = requiredColumn => getProjectBackgroundTasksColumns(formatDate)[requiredColumn];
      $[12] = formatDate;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    t6 = requiredColumns.map(t7);
    $[9] = formatDate;
    $[10] = requiredColumns;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = displayTotalCount ?? undefined;
  let t8;
  if ($[14] !== beforePage || $[15] !== dispatch || $[16] !== progressApiClient || $[17] !== projectApiClient || $[18] !== taskType) {
    t8 = async () => {
      await dispatch(updateBackgroundTasks({
        progressApiClient,
        projectApiClient,
        beforePage,
        taskType
      }));
    };
    $[14] = beforePage;
    $[15] = dispatch;
    $[16] = progressApiClient;
    $[17] = projectApiClient;
    $[18] = taskType;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const t9 = beforePage !== null;
  let t10;
  if ($[20] !== isLoading || $[21] !== sdbBackgroundsTasks || $[22] !== t6 || $[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
    t10 = <FaroTable entities={sdbBackgroundsTasks} uniqueIdKey="id" isLoading={isLoading} columns={t6} rowHeight={54} shouldHideCheckbox={true} totalCount={t7} onNextPage={t8} hasMoreItems={t9} tableType={TableType.backgroundTasks} paginationMode="server" />;
    $[20] = isLoading;
    $[21] = sdbBackgroundsTasks;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
}